const organizationSwedish = {
  common: {
    loading: "Laddar...",
    error: "Ett fel uppstod",
    save: "Spara",
    cancel: "Avbryt",
    yes: "Ja",
    no: "Nej"
  },
  header: {
    title: "Organisation",
    adminRole: "Administratör",
    employeeRole: "Anställd",
    adminDescription: "Hantera din organisation, teammedlemmar och kundtilldelningar",
    employeeDescription: "Se din organisation, teammedlemmar och kundtilldelningar"
  },
  messages: {
    confirmRemoveMember: "Är du säker på att du vill ta bort {email} från organisationen?",
    confirmCancelInvitation: "Är du säker på att du vill avbryta denna inbjudan?",
    confirmCancelSubscription: "Är du säker på att du vill säga upp denna prenumeration?"
  },
  notifications: {
    success: {
      invitationSent: "Inbjudan skickad till {email}",
      memberRemoved: "Medlem borttagen från organisationen",
      invitationCancelled: "Inbjudan avbruten",
      customerAssigned: "Kund tilldelad till anställd",
      assignmentRemoved: "Kundtilldelning borttagen",
      licenseAdded: "Licenser tillagda"
    },
    error: {
      general: "Ett fel uppstod",
      emailRequired: "Ange en e-postadress",
      noOrganization: "Ingen organisation hittades",
      memberExists: "Denna användare är redan medlem i organisationen",
      invitationExists: "Denna användare har redan blivit inbjuden till organisationen",
      billingPortal: "Ett fel uppstod vid öppnande av kundportalen. Försök igen senare."
    }
  },
  subscription: {
    card: {
      title: "LinkedIn Poster-licenser",
      status: {
        active: "Aktiv",
        trialing: "Provperiod",
        inactive: "Inaktiv"
      },
      currentPlan: "Nuvarande plan:",
      noPlan: "Ingen plan",
      licenseInfo: {
        total: "Totala licenser",
        assigned: "Tilldelade licenser",
        available: "Tillgängliga licenser"
      },
      trial: {
        info: "Din provperiod upphör om"
      },
      actions: {
        addLicenses: "Lägg till licenser",
        manageBilling: "Hantera betalning"
      }
    }
  },
  team: {
    card: {
      title: "Team",
      inviteButton: "Bjud in medlem",
      emptyState: {
        admin: "Ditt team är tomt. Bjud in teammedlemmar genom att klicka på \"Bjud in medlem\"-knappen.",
        employee: "Det finns inga teammedlemmar i organisationen ännu."
      },
      memberInfo: {
        you: "(Du)",
        admin: "Administratör",
        member: "Medlem",
        status: {
          active: "Aktiv",
          invited: "Inbjuden"
        },
        invitationBadge: "Inbjudan"
      }
    }
  },
  customerManagement: {
    card: {
      title: "Kundhantering",
      adminSubheader: "Tilldela kunder till anställda",
      employeeSubheader: "Översikt över kunder och tilldelningar",
      emptyState: {
        admin: "Det finns inga kunder i organisationen ännu. Bjud in kunder genom att välja \"Kund\" i inbjudningsformuläret.",
        employee: "Det finns inga kunder i organisationen ännu."
      },
      tableHeaders: {
        customer: "Kund",
        email: "E-post",
        status: "Status",
        assignedTo: "Tilldelad till",
        actions: "Åtgärder"
      },
      status: {
        active: "Aktiv",
        invited: "Inbjuden"
      },
      notAssigned: "Inte tilldelad",
      actions: {
        assign: "Tilldela kund",
        removeAssignment: "Ta bort tilldelning"
      }
    }
  },
  modals: {
    assignLicense: {
      title: "Tilldela licens",
      email: "E-post",
      licenseType: "Licenstyp",
      availableLicenses: "Tillgängliga licenser:",
      licenseTypes: {
        basic: "Basic",
        pro: "Professional",
        enterprise: "Enterprise"
      }
    },
    updateSubscription: {
      title: "Uppdatera prenumeration",
      quantity: "Antal licenser",
      preview: {
        plan: "Plan:",
        pricePerLicense: "Pris per licens:",
        total: "Totalt:"
      }
    },
    inviteMember: {
      title: "Bjud in teammedlem",
      email: "E-post",
      emailPlaceholder: "Ange teammedlemmens e-post",
      role: "Roll",
      roles: {
        employee: "Anställd (Kan hantera egna och andras profiler)",
        customer: "Kund (Kan endast logga in med LinkedIn)"
      },
      info: "En inbjudan kommer att skickas till denna e-post. När användaren accepterar inbjudan kommer de att tilldelas en licens.",
      employeeInfo: " Som anställd kan de hantera både egna och andras LinkedIn-profiler.",
      customerInfo: " Som kund kan de endast logga in med LinkedIn och kommer inte att ha tillgång till dashboarden.",
      availableLicenses: "Tillgängliga licenser:",
      sending: "Skickar inbjudan...",
      send: "Skicka inbjudan"
    },
    buyLicense: {
      title: "Köp fler licenser",
      info: "Du behöver köpa fler licenser för att kunna bjuda in fler medlemmar. Du har för närvarande {currentLicenses} licens(er).",
      quantity: "Antal licenser att lägga till",
      pricing: {
        info: "Varje licens ger en plats till en teammedlem",
        price: "Pris: 1490 kr exkl. moms/mån per licens (Det finns möjlighet att ange en rabattkod)",
        total: "Totalt: {total} kr exkl. moms/mån"
      },
      buy: "Köp licenser"
    },
    assignCustomer: {
      title: "Tilldela kund: {customerName}",
      selectEmployee: "Välj anställd",
      noEmployee: "Välj anställd",
      assign: "Tilldela kund"
    }
  }
};

export default organizationSwedish; 